/* eslint-disable */
function Pagination(el, page) {

    const pagination = el.querySelector(".pagination");
    const prev = el.querySelector(".prev");
    const next = el.querySelector(".next");
    const pagination_pages = pagination.querySelector(".pages");
    //const pagination_links = pagination.querySelectorAll("a");
    const pagination_links = pagination.querySelectorAll("button");
    this.click = () => { };

    pagination_links.forEach(link => {
        link.onclick = e => {
            e.preventDefault();
            //page = link.getAttribute("href");
            page = link.getAttribute("data-href");
            this.click(page);
        }
    })

    const pager = lastpage => {
        let html = "";

        if (lastpage < 8) {
            for (let i = 1; i <= lastpage; i++) {
                //html += `<a href="${i}" ${page == i ? `class="active"` : ``}>${i}</a>`;
                html += `<button data-href="${i}" ${page == i ? `class="active"` : ``}>${i}</button>`;
            }
        }

        else if (page > lastpage - 4) {
            //html += ` <a href="${lastpage - 4}" ${page === lastpage - 4 ? `class="active"` : ``}>${lastpage - 4}</a> ...`;
            html += ` <button data-href="${lastpage - 4}" ${page === lastpage - 4 ? `class="active"` : ``}>${lastpage - 4}</button> ...`;

            for (let i = lastpage - 3; i <= lastpage; i++) {
                //html += `<a href="${i}" ${page === i ? `class="active"` : ``}>${i}</a>`;
                html += `<button data-href="${i}" ${page === i ? `class="active"` : ``}>${i}</button>`;
            }
        }
        else {
            let pagestart = Number(page > 1 ? page - 1 : page);
            for (let i = pagestart; i < pagestart + 4; i++) {
                //html += `<a href="${i}" ${page === i ? `class="active"` : ``}>${i}</a>`;
                html += `<button data-href="${i}" ${page === i ? `class="active"` : ``}>${i}</button>`;
            }
            // html += `... <a href="${lastpage}">${lastpage}</a>`;
            html += `... <button data-href="${lastpage}">${lastpage}</button>`;
        }

        pagination_pages.innerHTML = html;

        pagination_pages.querySelectorAll("button").forEach(link => {
            link.onclick = e => {
                e.preventDefault();
                // page = link.getAttribute("href");
                page = link.getAttribute("data-href");
                this.click(page);
            }
        })

    }

    this.set = (last_page, newpage) => {
        page = newpage;

        if (page > 1) {
            prev.classList.remove("disabled");
            //prev.href = page - 1
            prev.setAttribute("data-href", page - 1);
        } else {
            prev.classList.add("disabled");
        }

        if (page === last_page) {
            next.classList.add("disabled");
        } else {
            next.classList.remove("disabled");
            //next.href = page + 1
            next.setAttribute("data-href", page + 1);

        }

        if (last_page >= 1) {
            pager(last_page);
            pagination.classList.remove("hide");
        }
        else {
            pagination.classList.add("hide");
        }

        if (last_page === 1) {
            pagination.classList.add("hide");
        }
    }

    this.set(Number(pagination.dataset.total), 1);
}
export default Pagination;
